module.exports = __webpack_public_path__ + "img/rollNum1.0f11e37c.png";